export const filterInputStyles = {
  input: {
    backgroundColor: "var(--mantine-color-white)",
    borderColor: "var(--mantine-color-gray-3)",
    borderRadius: 8,
    fontSize: 14,
    fontVariantNumeric: "tabular-nums",
  },
} as const;
